import React, { memo } from 'react';

import { Box, Button, Stack, Typography } from '@mui/material';
import { ErrorFilledIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { AiChatTestIds } from '../../../../AiChat.testIds';

import {
  DEFAULT_ERROR_MESSAGE,
  ERROR_ICON_SIZE,
  RETRY_BUTTON_LABEL,
  STOPPED_MESSAGE,
} from './FailedBotMessageContent.constants';
import {
  actionsStyles,
  containerStyles,
  errorTextStyles,
  headerStyles,
  iconStyles,
} from './FailedBotMessageContent.styles';

const FailedBotMessageContent = ({
  error = null,
  canRetry = true,
  isCancelled = false,
  onRetry = null,
}) => {
  const messageText = isCancelled ? STOPPED_MESSAGE : (error ?? DEFAULT_ERROR_MESSAGE);
  const isRetryShown = !isCancelled && canRetry && !!onRetry;

  return (
    <Box data-testid={AiChatTestIds.AI_BOT_MESSAGE_FAILURE} sx={containerStyles}>
      <Stack sx={headerStyles}>
        <Box sx={iconStyles}>
          <ErrorFilledIcon size={ERROR_ICON_SIZE} />
        </Box>
        <Typography sx={errorTextStyles} variant="medium14">
          {messageText}
        </Typography>
      </Stack>
      {isRetryShown && (
        <Box sx={actionsStyles}>
          <Button
            data-testid={AiChatTestIds.AI_BOT_MESSAGE_FAILURE_RETRY_BUTTON}
            size="small"
            variant="line"
            onClick={onRetry}
          >
            {RETRY_BUTTON_LABEL}
          </Button>
        </Box>
      )}
    </Box>
  );
};

FailedBotMessageContent.propTypes = {
  error: PropTypes.string,
  canRetry: PropTypes.bool,
  isCancelled: PropTypes.bool,
  onRetry: PropTypes.func,
};

export default memo(FailedBotMessageContent);
